var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-green",attrs:{"href":"#about","variant":"outline-light"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }